import { render, staticRenderFns } from "./AdList.vue?vue&type=template&id=3c0b60f5&scoped=true&"
import script from "./AdList.vue?vue&type=script&lang=js&"
export * from "./AdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b60f5",
  null
  
)

export default component.exports